<template>
  <div class="page_content module_microCompetency" aria-label="Create Micro Competency">
    <div class="row page-heading">
      <div class="col-8 input module_heading">
<!-- Menu -->
      <div class="pg_lft_menu">
        <b-dropdown no-caret class="navigation-menu" id="mcNavMenu">
          <template slot="button-content">
            <span id="mcNav" class="module_icon ic22-menu3x3">
              <span class="sr-only">menu</span>
            </span>
          </template>
          <div class="links new_menu">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="edit(1)" role="link" aria-label="About">
                <span class="lnk_txt">About</span>
              </b-dropdown-item>
              <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" aria-label="Content">
                <span class="lnk_txt">Content</span>
              </b-dropdown-item>
              <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="edit(3)" role="link" aria-label="Logic">
                <span class="lnk_txt">Progress/Performance</span>
              </b-dropdown-item>
              <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" aria-label="Logic">
                <span class="lnk_txt">Make a Copy</span>
              </b-dropdown-item>

          </div>
        </b-dropdown>
      </div>
<!-- End Menu -->
<!-- Header -->
        <span class="module_icon icon-microCompetency">ic</span>
          <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
            {{title}}
          </h1>
      </div>
      <div class="btn-container col-4">
        <template>
          <button class="btn-cancel" @click="cancel">
          <span class="icon-cross"></span>
          </button>
          <button class="btn btn-primary" @click="done(true)">done</button>
          <button class="btn btn-primary" @click="save(false)">save</button>
        </template>
      </div>
    </div>
<!-- End Header -->

       <div class="row page_content_container">
          <div class="curate-content-section row">
            <div class="col-12">
              <div class="row curate-header">
                  <div class="first-column ace_sec_txt" role="heading" aria-level="1" > Add Mocro Competencies to Course
                  </div>
                  <div class="second-column">
                    <button class="add-to-topic" @click="addToTopic">
                      <span class="icon-link2"></span>
                      <span class="link-source-text">
                        Add Mocro Competencies
                      </span>
                    </button>

                    <div class="second-column-content">
                        <div class="link-resource ace_sec_txt">Add Mocro Competencies</div>
                        <div class="search-box-container">
                          <a href="javascript://" class="icon-filter" v-b-modal.filtering></a>
                          <input type="text" class="input-search" placeholder="type in search term and/or click search" v-on:keyup.enter="searchWithTerms" v-model.trim="terms" aria-label="type in search term and/or click search">
                          <button class="btn" @click="searchWithTerms" aria-label="go">Go</button>
                        </div>
                    </div>
                </div>
              </div>

            <div class="row">
              <div :key="uuid" class="col-6 toc_panel">
                  <b-list-group>
                      <div class="list-group-item">
                          <div class="toc_row table-content-header">
                              <span class="icon-ic_ToC"></span>
                              <span class="header-text toc_hd_txt">{{title}}</span>
                              <div class="action_menu_container pg_hd_sec_menu">
                              </div>
                          </div>
                      </div>

                      <div class="content-scroll-column">
                          <b-list-group v-if="items">
                              <draggable v-model="items" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                                <transition-group type="transition" :name="'content-list'">
                                  <b-list-group-item class="topic-list-item" v-for="subtopic in items" :key="subtopic.uuid">
                                      <template  v-if="subtopic.action !== 'DELETE'">
                                        <div class="toc_row row_3 top-level-assets">
                                          <a class="row_link">
                                            <span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
                                            <span v-if="subtopic.fileType === 'video'" class="icon icon-video"></span>
                                            <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf"></span>
                                            <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile float-left"></span>
                                            <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text float-left"></span>
                                            <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video float-left"></span>
                                            <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip float-left"></span>
                                            <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm float-left"></span>
                                            <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word"></span>
                                            <span v-if="subtopic.fileType === 'xlsx' || subtopic.fileType === 'xls'" class="icon icon-file-excel"></span>
                                            <span v-if="subtopic.fileType === 'pptx' || subtopic.fileType === 'ppt'" class="icon icon-pagePPT"></span>
                                            <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL"></span>
                                            <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL"></span>
                                            <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image"></span>
                                            <span v-if="subtopic.fileType === 'other'"  class="icon icon-asset"></span>
                                            <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                                            <span class="lnk_txt">{{subtopic.title}}</span>
                                            <button class="icon-bin" @click="showDeleteItemConfirmBox('content', subtopic)" aria-label="delete"></button>
                                          </a>
                                        </div>
                                  </template>
                              </b-list-group-item>
                            </transition-group>
                           </draggable>
                    </b-list-group>
                  </div>
                  </b-list-group>

                  <div>
                      <b-modal class="delete-item-popup" ref="deleteItemModal" :title="'Delete'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                          <div>
                              <span>{{itemDeleteMessage}}</span>
                          </div>
                          <div slot="modal-header" class="popover-header">
                            <div class="popup-heading">Delete</div>
                            <button class="btn_close" aria-label="close" @click="closeDeleteConfirmBox">
                                 <span class="ic-close"></span>
                            </button>
                          </div>
                          <div slot="modal-footer" class="w-100">
                              <b-button @click="deleteItemAndCloseDeleteConfirmBox" class="btn button-primary float-right mr-2"> yes </b-button>
                              <b-button @click="closeDeleteConfirmBox" class="btn button-primary float-right mr-2"> no </b-button>
                          </div>
                      </b-modal>
                  </div>
              </div>

              <div class="col-6 curate-right-section datatable">
                <b-row class="search_result_container">
                  <b-col cols="12" class="px-0">
                    <div class="msg_no_result" v-if="results.length === 0">
                      No results found!
                    </div>
                    <b-list-group>
                      <div class="result_row table-content-header">
                        <div class="left-column float-left">
                          <div class="checkbox select-all">
                          <span class="form-checkbox" aria-labe="select all">
                            <input type="checkbox" @click="selectAll" v-model="allSelected" aria-labelledby="selectedAll">
                          </span>
                          </div>
                          <div class="out-of-total-item">
                                        <div class="selected-rows" id="selectedAll">Selected {{ this.selectedResult.length }} out of {{this.total}}</div>
                                    </div>
                        </div>
                        <div class="right-container">
                                    <div class="number-of-item">
                          <div class="number-of-item">
                                          <b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions">
                                                <b-dropdown-item-button v-for="option in sizeOptions" @click="changeSize(option)" aria-label="size options">{{option}}</b-dropdown-item-button>
                                          </b-dropdown>
                                      </div>
                                    </div>
                                    <div class="pagination btn_container pagination_sty3">
                                        <button type="button" class="btn btn_trans" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                                        <span class="current-page" aria-label="current page">{{pageNumber}}</span>
                                        <button type="button" class="btn btn_trans" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                                    </div>
                        </div>
                      </div>
                      <div class="content-scroll-column">
                        <div class="flex-column align-items-start result_row" v-for="(result, index) in results" :key="result.uuid" v-bind:class="{ added: result.isAdded }">
                            <div class="facet_list">
                              <div class="checkbox">
                              <span class="form-checkbox" v-if="!result.isAdded">
                                <input type="checkbox" :id="'ch_' + index" :value="result" :state = "updateSelectAll" v-model="selectedResult" :aria-labelledby="'selectEntity' + index">
                                <i class="form-icon"></i>
                              </span>
                              <span class="form-checkbox" v-if="result.isAdded">
                                <input type="checkbox" :id="'ch_' + index" disabled aria-label="disable field">
                                <i class="form-icon"></i>
                              </span>
                              </div>
                            </div>

                            <div class="result_block">
                              <div class="d-flex w-100">
                                <div class="title_icon">
                                  <div v-if="result.fileType === 'assessment'" class="icon-assessment float-left"></div>
                                  <div v-if="result.fileType === 'video'" class="icon-video float-left"></div>
                                  <div v-if="result.fileType === 'pdf'" class="icon-file-pdf float-left"></div>
                                  <span v-if="result.fileType === 'csv'" class="icon icon-csvFile float-left"></span>
                                  <span v-if="result.fileType === 'txt'" class="icon icon-file-text float-left"></span>
                                  <span v-if="result.fileType === 'mp4' || result.fileType === 'mp3'" class="icon icon-video float-left"></span>
                                  <span v-if="result.fileType === 'zip'" class="icon icon-file-zip float-left"></span>
                                  <span v-if="result.fileType === 'scorm'" class="icon icon-scorm float-left" style="color: #b8652a;"></span>
                                  <div v-if="result.fileType === 'doc' || result.fileType === 'docx'" class="icon-file-word float-left"></div>
                                  <div v-if="result.fileType === 'xlsx' || result.fileType === 'xls'" class="icon-file-excel float-left"></div>
                                  <div v-if="result.fileType === 'pptx' || result.fileType === 'ppt'" class="icon-pagePPT float-left"></div>
                                  <div v-if="result.fileType === 'html'" class="icon-pageURL float-left"></div>
                                  <div v-if="result.fileType === 'externalurl'" class="icon-pageURL float-left"></div>
                                  <div v-if="result.fileType === 'jpg' || result.fileType === 'jpeg' || result.fileType === 'png' || result.fileType === 'gif'" class="icon-image float-left"></div>
                                  <div v-if="result.fileType === 'other'"  class="icon-asset float-left"></div>
                                  <div v-if="!result.fileType" class="icon-folder float-left"></div>
                                </div>

                              <label :for="'ch_' + index" :id="'selectEntity' + index" class="title">{{result.title}}</label>
                              </div>
                            </div>
                        </div>
                      </div>
                    </b-list-group>
                  </b-col>
                </b-row>
              </div>

            </div>

            </div>
          </div>

        </div>

<!-- Filter Model -->

    <b-modal id="filtering" class="filter-popup" :busy="true" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header" class="header-section">
       <span class="icon-filter float-left"></span>
       <div class="popup-heading">Narrow Your Results</div>
       <button class="btn_close" aria-label="close" @click="closeFilterPopup">
            <span class="ic-close"></span>
       </button>
      </div>
      <div cols="3" class="facets">
        <div class="facet_block_container">
          <div class="facet_block">
            <div class="head">
              <div class="checkbox"></div>
               <div class="head_txt">Folders</div>
            </div>
            <div class="facet_row_container">
                <b-form-group aria-label="select folders list">
                    <b-form-checkbox-group plain stacked v-model="foldersSelected" aria-label="selected folders" :options="folders" />
                </b-form-group>
            </div>
          </div>
          <div class="facet_block">
             <div class="head">
                <div class="checkbox"></div>
                  <div class="head_txt">Entity Type</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.entityType>
                      <span class="collapsed icon-collapse"></span>
                      <span class="expand icon-expand"></span>
                    </b-btn>
                  </div>
              </div>
                <b-collapse visible id="entityType">
                  <div class="facet_row_container">
                    <b-form-group aria-label="entity type list">
                      <b-form-checkbox-group plain stacked v-model="indexesSelected" aria-label="select entity type" :options="indexes" disabled/>
                    </b-form-group>
                  </div>
                </b-collapse>
          </div>

          <div class="facet_block">
            <div class="head">
              <div class="checkbox"> </div>
              <div class="head_txt">Asset Type</div>
              <div class="icon_container">
                <b-btn v-b-toggle.assetType>
                  <span class="collapsed icon-collapse"></span>
                  <span class="expand icon-expand"></span>
                </b-btn>
              </div>
            </div>
            <b-collapse visible id="assetType">
              <div class="facet_row_container">
                <b-form-group aria-label="select asset type">
                  <b-form-checkbox-group plain stacked v-model="assetTypeSelected" aria-label="selected asset" :options="assetType" />
                </b-form-group>
              </div>
            </b-collapse>
          </div>
          </div><!-- facet_block_container -->
      </div><!-- facets -->
    </b-modal>
<!-- End Filter Model -->

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import '../../../assets/module/css/course/courseCurate.min.css'
import Vue from 'vue'
import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
import { getSimpleLibraryFilter } from '../../search/searchUtils.js'
import Vuelidate from 'vuelidate'
import {required, url, numeric, minValue} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

var EntityData = function (id, title, type) {
  this.id = id
  this.uuid = undefined
  this.title = title
  this.action = undefined
  this.originUuid = undefined
  this.rootOriginUuid = undefined
}

export default {
  name: 'course-curation-new',
  props: ['uuid'],
  components: {
    draggable
  },
  data: () => {
    return {
      title: 'Test',
      opstate: 1,
      itemTitle: '',
      itemUri: '',
      contentType: 'LOCAL',
      itemDescription: '',
      assessmentMaxAttempt: 1,
      topicUuid: '',
      subTopicUuid: '',
      itemToEdit: '',
      itemToDelete: '',
      itemDeleteMessage: '',
      items: [],
      entityId: 0,
      entityType: {
        TOPIC: 'LearningTopic',
        ASSET: 'LearningContent'
      },
      isDragging: false,
      delayedDragging: false,
      folders: [],
      foldersSelected: [],
      allFolders: [],
      privateLibraryList: [],
      publicLibraryList: [],
      selectionsForAction: [],
      userId: '',
      userRole: '',
      libraryList: '',
      indexes: [
        {
          text: 'Asset [0]',
          value: 'LearningContent',
          checked: true
        }
      ],
      indexesSelected: ['LearningTopic', 'LearningContent'],
      allIndexes: ['learningtopic', 'learningcontent'],
      assetType: [],
      assetTypeSelected: [],
      indexList: '',
      facets: {},
      filter: {},
      query: {},
      sort: [{lastUpdatedTime: {order: 'desc'}}],
      source: ['title', 'uuid', 'name', 'description', 'type', 'creationTime', 'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'localPractice', 'maxAttempt', 'whiteListed', 'blackListed'],
      sizeOptions: [ 10, 50, 100 ],
      terms: undefined,
      selectedComptency: undefined,
      selectedResult: [],
      allSelected: false,
      alreadyAddedResult: '',
      selectMCFromList: '',
      isFirstTimeLoad: true
    }
  },

  validations: {
    contentUri: {
      required,
      url
    },
    assessmentMaxAttempt: {
      required,
      numeric,
      minVal: minValue(1)
    }
  },

  mounted () {
  this.selectedComptency = this.uuid
    this.loadCourseDetail(this.uuid).then((res) => {
      this.title = res.title
    })
    this.loadCourseTopics(this.uuid).then((res) => {
//      this.topics = res.preRequisites
      this.renderTopicPlan(this.topics, this.items)
      this.userId = localStorage.getItem('userid')
      this.userRole = localStorage.getItem('userrole')
      this.loadLibrariesForUser(this.userId).then(learningSpaces => {
        for (var i = 0; i < learningSpaces.length; i++) {
          var learningSpace = learningSpaces[i]
          const category = learningSpace.category
          if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
            this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + ' [0]', checked: true})
            this.allFolders.push(learningSpace.uuid)
            this.foldersSelected.push(learningSpace.uuid)
            if (category !== 'Institute' && category !== 'User_Private') {
              this.publicLibraryList.push(learningSpace.uuid)
            }
            if (category === 'User_Private') {
              this.privateLibraryList.push(learningSpace.uuid)
            }
          }
        }
        this.terms = ''
        this.constructQuery()
      })
    })
  },

  methods: {
    ...mapActions([
      'loadCourseTopics',
      'loadCourseTopics',
      'updateMicroCompetencyPrereqs',
      'loadSearchResults',
      'loadLibrariesForUser',
      'constructSearchQuery',
      'updateResultIsAdded',
      'updateResultIsAddedByUUID',
      'updateResultMCInfo',
      'updateResultMCInfoByUUID',
      'updateFrom',
      'loadAddPrePostCompetency',
      'updatePageNumber',
      'updateSize'
    ]),
    done(isDone){
            this.save(isDone)
    },
    save(isDone){
        this.$refs.loadingModal.show()
        let dataObj = {uuid:this.uuid, preRequisites: this.items}
        this.updateMicroCompetencyPrereqs(dataObj).then(res => {
          this.items = []
          this.topics = res.preRequisites
          this.renderTopicPlan(this.topics, this.items)
          this.updateSelectedResults()
          this.$refs.loadingModal.hide()
          this.showMessage('Saved Successfully', 'success')
          if (isDone) {
                this.edit(1)
          }

        })
    },
    showMessage (message, mType) {
      this.$notify({
        group: 'notify',
        type: mType,
        title: '',
        text: message
      })
    },

    cancel(){
      this.edit(1)
    },
    edit (opValue){
      return this.$router.push({ name: 'microCompetencyEdit', params: { uuid: this.uuid , opstate: opValue} })
    },

    updateFolder () {
      this.constructQuery()
    },

    updateFacet () {
      this.constructQuery()
    },

    addToTopic () {
      if (this.selectedComptency) {
            for (var m = 0; m < this.selectedResult.length; m++) {
              var entityToBeAdded = this.createNewEntity(this.selectedResult[m], 'COPY')
              this.updateResultIsAddedByUUID(entityToBeAdded.uuid)
              this.items.push(entityToBeAdded)
            }
        }
        this.selectedResult = []
        $('.add-to-topic').hide()
    },

    closeMappingPopup (competencyMappingPopup) {
      this.$root.$emit('bv::hide::popover', competencyMappingPopup)
    },

    closeFilterPopup () {
      this.$root.$emit('bv::hide::modal', 'filtering')
    },

    updateSelectedResults () {
      for (var i = 0; i < this.topics.length; i++) {
          for (var m = 0; m < this.results.length; m++) {
            if (this.topics[i].action === undefined || this.topics[i].action !== 'DELETE') {
                  if ((this.results[m].uuid === this.topics[i].originUuid) || (this.results[m].uuid === this.topics[i].uuid)) {
                    this.updateResultIsAdded({index: m, status: true})
                  }
                }
              }
      }
    },

    selectAll () {
      if (this.allSelected === false) {
        var selectedResult = []
        this.results.forEach(function (result) {
          selectedResult.push(result)
        })
        this.selectedResult = selectedResult
      } else {
        this.selectedResult = []
      }
      if(this.selectedResult.length>0){
        $('.add-to-topic').show()
      }
    },

    prevPage () {
      if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
        this.updatePageNumber(this.pageNumber - 1)
        this.updateFrom(this.from - this.size)
        this.constructQuery(false)
      }
    },

    nextPage () {
      if ((this.from + this.size) <= this.total) {
        this.updatePageNumber(this.pageNumber + 1)
        this.updateFrom(this.from + this.size)
        this.constructQuery(false)
      }
    },

    changeSize (option) {
      this.updateSize(option)
      this.updateFrom(0)
      this.updatePageNumber(1)
      this.constructQuery()
    },

    removeSelected (entity) {
      for (var m = 0; m < this.results.length; m++) {
        if ((this.results[m].uuid === entity.originUuid) || (this.results[m].uuid === entity.rootOriginUuid)) {
          this.updateResultIsAdded({index: m, status: false})
          var mcInfo = {
            index: m,
            mc: ''
          }
          this.updateResultMCInfo(mcInfo)
        }
      }
    },

    addCompetency (uuid, children) {
      this.selectedComptency = uuid
      if (this.selectedResult.length > 0) {
        $('.add-to-topic').show()
      } else {
        $('.add-to-topic').hide()
      }
    },

    addResource (result) {
      this.selectedResult = result
    },

    activateLinkResourseButton () {
      if (this.selectedComptency !== undefined) {
        for (var m = 0; m < this.results.length; m++) {
          if ($('#ch_' + m).is(':checked') === true) {
            $('.add-to-topic').show()
            break
          } else {
            $('.add-to-topic').hide()
          }
        }
      }
    },

    searchWithTerms () {
      this.constructQuery()
    },

    constructQuery () {
      // construct the libraryList
      this.libraryList = []
      this.indexList = []

      for (var i = 0; i < this.allFolders.length; i++) {
        if (this.libraryList.length === 0) {
          this.libraryList = this.allFolders[i]
        } else {
          this.libraryList = this.libraryList + ',' + this.allFolders[i]
        }
      }
      // construct the indexList
      for (i = 0; i < this.allIndexes.length; i++) {
        if (this.indexList.length === 0) {
          this.indexList = this.allIndexes[i]
        } else {
          this.indexList = this.indexList + ',' + this.allIndexes[i]
        }
      }

      // construct facets
      this.facets = {
        'library': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': 'owningLibraryId.keyword',
                'size': 100
              }
            }
          },
          'filter': this.getFacetFilter('owningLibraryId')
        },
        'type': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': '_type'
              }
            }
          },
          'filter': this.getFacetFilter('_type')
        },
        'assetType': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': 'fileType.keyword',
                'size': 100
              }
            }
          },
          'filter': this.getFacetFilter('fileType')
        }
      }

      // construct filter
      this.filter = this.generateFilter()

      this.constructSearchQuery({ terms: this.terms, sort: this.sort, source: this.source, from: this.from, size: this.size, indexList: this.indexList, libraryList: this.libraryList, privateLibraryList: this.privateLibraryList, publicLibraryList: this.publicLibraryList, userId: this.userId, foldersSelected: this.foldersSelected, aggs: this.facets, filter: this.filter }).then((res) => {
        this.updateSelectedResults()
      })
    },

    generateFilter () {
      // origin UUID
      var filterObj = {
        'bool': this.originUuidCheck()
      }

      // Folders
      if (this.foldersSelected.length > 0) {
        let orQuery = {
          'bool': {
            'should': [
              getSimpleLibraryFilter(this.foldersSelected)
            ]
          }
        }
        filterObj.bool.must.push(orQuery)
      }

      // Content Type
      if (this.indexesSelected.length > 0) {
        var terms = {
          'terms': {
            '_type': this.indexesSelected
          }
        }
        filterObj.bool.must.push(terms)
      }
      // Assest Type
      if (this.assetTypeSelected.length > 0) {
        var assetTerms = {
          'terms': {
            'fileType': this.assetTypeSelected
          }
        }
        filterObj.bool.must.push(assetTerms)
      }
      return filterObj
    },

    getFacetFilter (facetType) {
      var facetFilterObj = {
        'bool': this.originUuidCheck()
      }

      if (facetType === 'owningLibraryId') {
        facetFilterObj.bool.must.push(getSimpleLibraryFilter(this.allFolders))
      } else if (facetType !== 'enrolledCourses') {
        if (this.foldersSelected.length > 0) {
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(this.foldersSelected)
              ]
            }
          }
          facetFilterObj.bool.must.push(orQuery)
        }
        if (facetType === 'fileType') {
          var terms = {
            'terms': {
              '_type': this.indexesSelected
            }
          }
          facetFilterObj.bool.must.push(terms)
        }
      }

      return facetFilterObj
    },

    originUuidCheck () {
      var originUuidCheck = {
        'must': [],
        'must_not': {
          'exists': {
            'field': 'originUuid'
          }
        }
      }
      return originUuidCheck
    },

    onMove (ev) {
      if (ev.draggedContext.element.action === undefined || ev.draggedContext.element.action !== 'COPY') {
        ev.draggedContext.element.action = 'MOVE'
      }
    },

    createNewEntity (item, action) {
      if (item) {
        var type = this.entityType.TOPIC
        var id = this.entityId++
        var entity = new EntityData(id, item.title, type)
        if (item.uuid) {
          entity.uuid = item.uuid
        }
        if (item.originUuid) {
          entity.originUuid = item.originUuid
        }
        if (item.rootOriginUuid) {
          entity.rootOriginUuid = item.rootOriginUuid
        }
        if (action) {
          entity.action = action
        }
        return entity
      }
    },

    renderTopicPlan (plan, data, action) {
      if (plan) {
        $.each(plan, (index, item) => {
          var newEntity = this.createNewEntity(item)
          if (action) {
            newEntity.action = action
          }
          data.push(newEntity)
        })
      }
    },

    switchClass (rowId) {
      var elem = $('#rw_' + rowId)
      if (elem.hasClass('ic-expand_r')) {
        elem.removeClass('ic-expand_r')
        elem.addClass('ic-collapse_r')
      } else {
        elem.removeClass('ic-collapse_r')
        elem.addClass('ic-expand_r')
      }
    },

    addExpandClass (rowId) {
      $('#rw_' + rowId).toggleClass('row_expanded row_collapsed')
    },

    showDeleteItemConfirmBox (type, item) {
      this.itemToDelete = item
      if (type === 'competency') {
        this.itemDeleteMessage = 'Are you sure you want to delete this competency?'
      } else if (type === 'microCompetency') {
        this.itemDeleteMessage = 'Are you sure you want to delete this micro competency?'
      } else if (type === 'content') {
        if (item.customType === 'ASSESSMENT') {
          this.itemDeleteMessage = 'Are you sure you want to delete this knowledge check?'
        } else {
          this.itemDeleteMessage = 'Are you sure you want to delete this resource?'
        }
      }
      this.$refs.deleteItemModal.show()
      $('#tc_' + this.itemToDelete.uuid).css('background', '#f9e4e1')
    },

    closeDeleteConfirmBox () {
      $('#tc_' + this.itemToDelete.uuid).css('background', 'none')
      this.$refs.deleteItemModal.hide()
    },

    deleteItemAndCloseDeleteConfirmBox () {
      this.itemToDelete.action = 'DELETE'
      this.closeDeleteConfirmBox()
      this.removeSelected(this.itemToDelete)
      this.constructQuery()
    },

    deleteChild (data) {
      $.each(data, (i, item) => {
        item.action = 'DELETE'
        if (item.type === this.entityType.TOPIC) {
          this.deleteChild(item.children)
        }
      })
    },

    afterSave (data) {
      this.items = []
      this.renderTopicPlan(data, this.items)
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'results': state => state.search.results,
      'total': state => state.search.total,
      'topics': state => state.course.topics,
      'facetResults': state => state.search.aggregations,
      'from': state => state.search.from,
      'pageNumber': state => state.search.pageNumber,
      'size': state => state.search.size
    }),

    itemTitleState () {
      return this.itemTitle.length > 0
    },
    newCompetencyTitleState () {
      return this.newCompetencyTitle.length > 0
    },

    updateSelectAll () {
      if (this.selectedComptency !== undefined) {
        if (this.selectedResult.length === this.results.length) {
          this.allSelected = true
          $('.add-to-topic').show()
        } else {
          this.allSelected = false
        }
        if ((this.selectedResult.length && this.results.length) === 0) {
          this.allSelected = false
          $('.add-to-topic').hide()
        }
        if (this.selectedResult.length > 0) {
          $('.add-to-topic').show()
        }
      }
    },

    dragOptions () {
      return {
        animation: 0,
        group: 'content',
        disabled: false,
        ghostClass: 'ghost'
      }
    }

  },

  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    },

    selectMCFromList (newValue) {
      console.log('New Select MC FROM list: ', this.selectMCFromList)
    },

    foldersSelected (newFoldersSelected) {
      this.updateFacet()
      this.constructQuery()
    },

    facetResults (newFacet) {
      // process library
      var libTerms = this.facetResults.library.termObj.buckets || []
      var lib = {}
      for (var i = 0; i < libTerms.length; i++) {
        lib = libTerms[i]
        for (var j = 0; j < this.folders.length; j++) {
          if (this.folders[j].value === lib.key) {
            this.folders[j].text = this.folders[j].text.substr(0, this.folders[j].text.indexOf('[')) + '[' + lib.doc_count + ']'
          }
        }
      }

      // process content type
      var typeTerms = this.facetResults.type.termObj.buckets || []
      var type = {}
      for (i = 0; i < typeTerms.length; i++) {
        type = typeTerms[i]
        for (j = 0; j < this.indexes.length; j++) {
          if (this.indexes[j].value === type.key) {
            this.indexes[j].text = this.indexes[j].text.substr(0, this.indexes[j].text.indexOf('[')) + '[' + type.doc_count + ']'
          }
        }
      }

      // process assets
      var assetTerms = this.facetResults.assetType.termObj.buckets || []
      this.assetType = []
      var asset = {}
      for (i = 0; i < assetTerms.length; i++) {
        let assetTerm = assetTerms[i]
        asset = {
          'text': assetTerm.key + ' [' + assetTerm.doc_count + ']',
          'value': assetTerm.key
        }
        this.assetType.push(asset)
      }
    },
    assetTypeSelected (newAssetTypeSelected) {
      this.constructQuery()
    },

    indexesSelected (newIndexesSelected) {
      this.constructQuery()
    }
  }
}
</script>

<style scoped>

.lnk_txt {
    margin-left: 42px;
    width: 74%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    border: dashed;
    background: #ebebeb;
}
.inputTitle {
    width: 92%;
    height: 15px;
}

.title {
    font-size: 17px
}

.close-button {
  position: absolute;
  right: 18px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  justify-content: center;
  font-size: 13px;
  padding: 0px;
  top: 13px;
}

.content-section {
  float: left;
    width: 100%;
    margin-top: 5px;
    margin-left: 6px;
    margin-bottom: 13px;
}

.collapsed > .collapsed,
:not(.collapsed) > .expand {
  display: none;
}

.table-content-header, .table-content-header:hover {
  border-bottom: solid 1px rgb(217, 217, 217) !important;
  background: rgb(249, 249, 249) !important;
}

.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
}

</style>



// WEBPACK FOOTER //
// src/app/microCompetency/components/CourseCurationNew.vue